export const BANNER_LIST_REQUEST = "BANNER_LIST_REQUEST";
export const BANNER_LIST_SUCCESS = "BANNER_LIST_SUCCESS";
export const BANNER_LIST_FAIL = "BANNER_LIST_FAIL";

export const BANNER_ADD_REQUEST = "BANNER_ADD_REQUEST";
export const BANNER_ADD_SUCCESS = "BANNER_ADD_SUCCESS";
export const BANNER_ADD_FAIL = "BANNER_ADD_FAIL";

export const BANNER_UPDATE_REQUEST = "BANNER_UPDATE_REQUEST";
export const BANNER_UPDATE_SUCCESS = "BANNER_UPDATE_SUCCESS";
export const BANNER_UPDATE_FAIL = "BANNER_UPDATE_FAIL";

export const BANNER_DELETE_REQUEST = "BANNER_DELETE_REQUEST";
export const BANNER_DELETE_SUCCESS = "BANNER_DELETE_SUCCESS";
export const BANNER_DELETE_FAIL = "BANNER_DELETE_FAIL";

export const VIDEO_BANNER_LIST_REQUEST = "VIDEO_BANNER_LIST_REQUEST";
export const VIDEO_BANNER_LIST_SUCCESS = "VIDEO_BANNER_LIST_SUCCESS";
export const VIDEO_BANNER_LIST_FAIL = "VIDEO_BANNER_LIST_FAIL";

export const VIDEO_BANNER_UPLOAD_REQUEST = "VIDEO_BANNER_UPLOAD_REQUEST";
export const VIDEO_BANNER_UPLOAD_SUCCESS = "VIDEO_BANNER_UPLOAD_SUCCESS";
export const VIDEO_BANNER_UPLOAD_FAIL = "VIDEO_BANNER_UPLOAD_FAIL";

export const VIDEO_BANNER_DELETE_REQUEST = "VIDEO_BANNER_DELETE_REQUEST";
export const VIDEO_BANNER_DELETE_SUCCESS = "VIDEO_BANNER_DELETE_SUCCESS";
export const VIDEO_BANNER_DELETE_FAIL = "VIDEO_BANNER_DELETE_FAIL";

export const USER_VIDEO_BANNER_LIST_REQUEST = "USER_VIDEO_BANNER_LIST_REQUEST";
export const USER_VIDEO_BANNER_LIST_SUCCESS = "USER_VIDEO_BANNER_LIST_SUCCESS";
export const USER_VIDEO_BANNER_LIST_FAIL = "USER_VIDEO_BANNER_LIST_FAIL";

export const OFFER_BANNER_LIST_REQUEST = "OFFER_BANNER_LIST_REQUEST";
export const OFFER_BANNER_LIST_SUCCESS = "OFFER_BANNER_LIST_SUCCESS";
export const OFFER_BANNER_LIST_FAIL = "OFFER_BANNER_LIST_FAIL";

export const OFFER_BANNER_ADD_REQUEST = "OFFER_BANNER_ADD_REQUEST";
export const OFFER_BANNER_ADD_SUCCESS = "OFFER_BANNER_ADD_SUCCESS";
export const OFFER_BANNER_ADD_FAIL = "OFFER_BANNER_ADD_FAIL";

export const OFFER_BANNER_UPDATE_REQUEST = "OFFER_BANNER_UPDATE_REQUEST";
export const OFFER_BANNER_UPDATE_SUCCESS = "OFFER_BANNER_UPDATE_SUCCESS";
export const OFFER_BANNER_UPDATE_FAIL = "OFFER_BANNER_UPDATE_FAIL";

export const OFFER_BANNER_DELETE_REQUEST = "OFFER_BANNER_DELETE_REQUEST";
export const OFFER_BANNER_DELETE_SUCCESS = "OFFER_BANNER_DELETE_SUCCESS";
export const OFFER_BANNER_DELETE_FAIL = "OFFER_BANNER_DELETE_FAIL";

export const OFFER_BANNER_ACTIVE_REQUEST = "OFFER_BANNER_ACTIVE_REQUEST";
export const OFFER_BANNER_ACTIVE_SUCCESS = "OFFER_BANNER_ACTIVE_SUCCESS";
export const OFFER_BANNER_ACTIVE_FAIL = "OFFER_BANNER_ACTIVE_FAIL";
export const CLEAR_ACTIVE_OFFER_BANNER = "CLEAR_ACTIVE_OFFER_BANNER";

export const TOP_OFFER_LIST_REQUEST = "TOP_OFFER_LIST_REQUEST";
export const TOP_OFFER_LIST_SUCCESS = "TOP_OFFER_LIST_SUCCESS";
export const TOP_OFFER_LIST_FAIL = "TOP_OFFER_LIST_FAIL";

export const TOP_OFFER_CREATE_REQUEST = "TOP_OFFER_CREATE_REQUEST";
export const TOP_OFFER_CREATE_SUCCESS = "TOP_OFFER_CREATE_SUCCESS";
export const TOP_OFFER_CREATE_FAIL = "TOP_OFFER_CREATE_FAIL";

export const TOP_OFFER_UPDATE_REQUEST = "TOP_OFFER_UPDATE_REQUEST";
export const TOP_OFFER_UPDATE_SUCCESS = "TOP_OFFER_UPDATE_SUCCESS";
export const TOP_OFFER_UPDATE_FAIL = "TOP_OFFER_UPDATE_FAIL";

export const TOP_OFFER_DELETE_REQUEST = "TOP_OFFER_DELETE_REQUEST";
export const TOP_OFFER_DELETE_SUCCESS = "TOP_OFFER_DELETE_SUCCESS";
export const TOP_OFFER_DELETE_FAIL = "TOP_OFFER_DELETE_FAIL";

export const TOP_OFFER_ACTIVATE_REQUEST = "TOP_OFFER_ACTIVATE_REQUEST";
export const TOP_OFFER_ACTIVATE_SUCCESS = "TOP_OFFER_ACTIVATE_SUCCESS";
export const TOP_OFFER_ACTIVATE_FAIL = "TOP_OFFER_ACTIVATE_FAIL";
